var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BaseModal",
        {
          attrs: {
            centerScreen: "",
            bus: _vm.busModal,
            persistent: "",
            centerAndDecreasesPadding: "",
            maxWidth: "55%",
            closeColor: "#8e8e8e",
            backgroundColor: "white"
          },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function(ref) {
                var close = ref.close
                return [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Fechar ")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("div", { staticClass: "pb-6" }, [
            _c("div", { staticClass: "modal-title-container" }, [
              _c("span", { staticClass: "modal-title" }, [
                _vm._v("Gerenciar Respostas Rápidas")
              ])
            ]),
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                { staticClass: "pa-4" },
                [
                  _c("BaseTable", {
                    attrs: {
                      headers: _vm.tableHeaders,
                      items: _vm.respostas,
                      loading: _vm.loading,
                      "show-search": "",
                      "disable-margin-top": "",
                      "hide-default-footer": "",
                      "items-per-page": -1,
                      "no-data-text": "Nenhuma resposta rápida cadastrada",
                      "no-results-text": "Nenhuma resposta encontrada",
                      "data-test": "respostas-table"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cornerAction",
                        fn: function() {
                          return [
                            _c(
                              "BaseButton",
                              {
                                attrs: {
                                  primary: "",
                                  "fit-content": "",
                                  "min-width": "auto",
                                  "data-test": "add-resposta-btn"
                                },
                                on: { click: _vm.openNewForm }
                              },
                              [_vm._v(" Nova Resposta ")]
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "item.titulo",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("span", [
                              _vm._v(" " + _vm._s(item.titulo) + " ")
                            ])
                          ]
                        }
                      },
                      {
                        key: "item.conteudo",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "d-inline-block text-truncate",
                                staticStyle: { "max-width": "320px" },
                                attrs: { title: item.conteudo }
                              },
                              [_vm._v(" " + _vm._s(item.conteudo) + " ")]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-center justify-center"
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        "data-test":
                                                          "edit-resposta-btn"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.openEditForm(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c("icon-svg", {
                                                    attrs: {
                                                      name: _vm.icons.edit,
                                                      size: "16",
                                                      color: "#8E8E8E"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [_c("span", [_vm._v("Editar")])]
                                ),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "div",
                                                _vm._g(
                                                  { staticClass: "d-flex" },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-btn",
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          "data-test":
                                                            "delete-resposta-btn",
                                                          disabled:
                                                            item.loading_delete
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onDeleteClick(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    [
                                                      item.loading_delete
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                indeterminate:
                                                                  "",
                                                                size: "16",
                                                                width: "2",
                                                                color: "grey"
                                                              }
                                                            }
                                                          )
                                                        : _c("icon-svg", {
                                                            attrs: {
                                                              name:
                                                                _vm.icons
                                                                  .delete,
                                                              size: "16",
                                                              color: "#8E8E8E"
                                                            }
                                                          })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [_c("span", [_vm._v("Remover")])]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _c("ModalRespostaRapida", {
        attrs: {
          api: _vm.api,
          "open-key": _vm.respostaRapidaKey,
          "salva-key": _vm.salvaKey
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }